module.exports = __webpack_public_path__ + "img/icon1.f5393bb5.png";